const api = {}
import _ from "lodash"
import date from "date-and-time"
import moment from "moment"
import {Signal} from "signals"
import config from "./config"
import SignatureStore from "./pages/components/Step/SignatureStore"

//Debug
window.moment   = moment
api.config      = config
api.stepnumbers = new Map()

const TRACK_ID_EXTRA_SIGNATURE = "EXTRA_SIG_EXTERNAL_TECH"
api.TRACK_ID_EXTRA_SIGNATURE   = TRACK_ID_EXTRA_SIGNATURE
let api_url = window.__MFR_BASE_API || "https://portal.mobilefieldreport.com/mfr/Form"

// DEV SERVER USES PROXY TO CIRCUMVENT CORS
if ( document.location.host === "localhost:3000" ) api_url = "/mfr/Form"

// Expose api_url for use in components (e.g., image sources)
api.baseUrl = api_url

const getToken = () => {
  let token

  try {
    // Token can be in search (?token=XXX) or hash (#/?token=XXX)
    const search = document.location.search || document.location.hash.split("?")[1]
    if (search) {
      const params = new URLSearchParams(search.startsWith("?") ? search : "?" + search)
      token = params.get("token")
    }
  } catch (e) {
    console.warn( "Error parsing the document location", e )
  }

  if ( !token ) {
    token = localStorage.getItem( "token" )
  }

  if ( !token ) {
    console.error( "Token not found" )
    return token
  }
  localStorage.setItem( "token", token )
  return token
}

let token = getToken()

const request = (endpoint, options = {}) => {
  let headers = new Headers()
  headers.append( "pragma", "no-cache" )
  headers.append( "cache-control", "no-cache" )
  options.cache    = "no-store"
  options.headers  = options.headers || headers
  var questionMark = "?"
  if ( endpoint.indexOf( "?" ) !== -1 ) {
    questionMark = "&"
  }

  const cacheFlag = Math.random().toString(36).substring(7)
  return fetch( `${api_url}${endpoint}${questionMark}token=${token}&cache=${cacheFlag}`, options )
    .then( res => {
      let out = {}
      try {
        out = res.json()
      } catch (e) {
        console.error( "Received non-JSON response", e )
      }
      return out
    } )
    .catch( e => {
      console.error( "Error loading from API:", e )
      api.error = true
    } )
}

// set date language
date.locale( "de" )
moment.locale( "de" )

const defaultOrder = {
  Appointments: []
}

class Order {
  constructor(order = {}) {
    Object.assign( this, defaultOrder, order )
    this.Steps = _.map( order.Steps, step => new Step( step ) )

    // create Signature step if not already in place
    let hasSignature = this.Steps.filter( step => step.TrackingId === TRACK_ID_EXTRA_SIGNATURE )[ 0 ]
    let isRejected   = this.StateCode === "eSubcontractorRejected"
    if ( isRejected ) return
    if ( !hasSignature ) {
      setTimeout( () => api.postSignatureStep(), 500 )
    }
  }
}

class Step {
  constructor(step) {
    this.hydrate( step )
  }

  hydrate(step) {
    Object.assign( this, step )
    this.Data = JSON.parse( step.Data )
    if ( this.Data && this.Data.fields && this.Data.fields.field ) {
      this.fields = this.Data.fields.field.map( field => new Field( field ) )
    }
  }
}

class Field {
  constructor(field) {
    Object.assign( this, field )
    let config = {
      facets: _.cloneDeep( field.facets )
    }

    if ( Array.isArray( config.facets ) && config.facets.length >= 1 ) {
      let facet          = _.first( config.facets ).facet
      config.Enumeration = _.first( facet.filter( facet => facet.type.match( /enumeration/gi ) ) )
      config.choicetype  = _.first( facet.filter( facet => facet.type === "choicetype" ) )
      config.ErrorRange  = _.first( facet.filter( facet => facet.type === "ErrorRange" ) )
      config.unit        = _.first( facet.filter( facet => facet.type === "unit" ) )
      config.datatype    = _.first( facet.filter( facet => facet.type === "datatype" ) )
      config.result      = field.result
      try {
        if ( typeof config.result === "string" ) config.result = config.result.split( ";" )
        if ( config.Enumeration ) config.Enumeration.value = config.Enumeration.value.split( ";" )
        if ( config.ErrorRange ) config.ErrorRange.value = config.ErrorRange.value.split( ";" )
      } catch (e) {
        console.warn( "Error while parsing field data", e )
      }
    }
    this.config = config
  }

  setResult(result) {
    this.result = result
  }

}

api.injectHistory = (history) => {
  api.history = history
}

api.getFinishedSteps = () => {
  let steps = api.getSteps()
  return steps.filter( step => step.IsDone === true ).length
}

api.getOrder = () => {
  return api.order
}

// only returns a subset of available steps
api.getSteps = () => {
  let filteredSteps = api.order.Steps.filter( step => {
    return _.includes( [
      0, 1, 2, 3, 5
    ], step.Type )
  } )
    .filter( step => step.TrackingId !== TRACK_ID_EXTRA_SIGNATURE )
  return filteredSteps || []
}

api.formatDate = function(field, format) {
  if ( !field ) return "-"
  let human = makeDateHumanreadable( field, format )
  return human
}

api.getStep = id => {
  let step = _.filter( api.order.Steps, step => Number( id ) === Number( step.Id ) )
  step     = _.first( step )
  return step
}

api.getContact = (index = 0) => {
  let contacts = api.order.Contacts
  if ( contacts && Array.isArray( contacts ) ) {
    return api.order.Contacts[ index ] || {}
  }
  return {}
}

api.getAllAttachments = () => {
  let byStepId = {}
  let flatList = []
  _.each( api.order.Steps, step => {
    if ( step.Attachments && step.Attachments.length > 0 ) {
      byStepId[ step.Id ] = step.Attachments
      flatList.push( ...step.Attachments )
    }
  } )
  let documents = api.order.Documents
  // flatList.push(...documents)
  return {
    byStepId, flatList, documents
  }
}

api.getAppointment = () => {
  let appointments = api.order.Appointments || []
  if ( appointments.length === 0 ) {
    return {}
  }
  return api.order.Appointments[ 0 ]
}

api.error              = false
api.signals            = {}
api.signals.updated    = new Signal()
api.signals.progress   = new Signal()
api.signals.stepChange = new Signal()
api.signatureStore = new SignatureStore(api)

api.progress = () => {
  let progress = api.getProgress()
  api.signals.progress.dispatch( { progress } )
}

api.getExternalSignatureStep = () => {
  let order = api.getOrder()
  return order.Steps.filter( step => step.TrackingId === "EXTRA_SIG_EXTERNAL_TECH" )[ 0 ]
}

api.getContactPersons = () => {
  let serviceRequest = api.getOrder()
  if ( !serviceRequest || !serviceRequest.Customer ) return []

  let companyId = serviceRequest.Customer.Id

  var contactsToReturn = _.filter( serviceRequest.Contacts, contact => (contact.CompanyId !== companyId) && (!contact.IsUser) )

  if ( serviceRequest.ServiceObjects ) {
    _.forEach( serviceRequest.ServiceObjects, function(tmpSO) {
      if ( tmpSO.Contacts ) {
        contactsToReturn = _.union( contactsToReturn, tmpSO.Contacts )
      }
    } )
  }
  return contactsToReturn
}

api.getProgress = () => {
  let steps = api.getSteps()
  if ( !steps || steps.length === 0 ) {
    return 100
  }

  let totalSteps = steps.length
  let closed     = steps
    .map( step => Number( !!step.IsDone ) )
    .reduce( ( (sum, step) => {
      return sum + step
    }) )
  return Math.min( Math.ceil( closed / totalSteps * 100 ), 100 )
}

api.fail = ({ errorCode }) => {
  api.order.StateCode = "eCustomError"
  api.errorCode       = errorCode
  _LTracker.push( { message: `EXTERNALTECHNICIAN: ServiceRequest::fail::updateState ${errorCode}`, level: "ERROR" } )
  document.location.replace( "#/error" )
}

api.updateState = (stateCode, message) => {
  console.info( `reject state`, stateCode, message )
  api.order.StateCode = stateCode
  let body            = {}
  if ( message ) {
    body = { Message: message }
  }
  return request( `/State/${stateCode}`, {
    method:  "PUT", headers: {
      "Accept": "application/json, text/plain, */*", "Content-Type": "application/json"
    }, body: JSON.stringify( body )
  } )
    .then( res => {
      if ( isError( res ) ) {
        console.error( "Error Updating State", res[ 0 ] )
        // api.fail({
        //   errorCode: `${api.order.Id}:${api.order.ExternalId}::${stateCode}`
        // })
        return request( `/State/${stateCode}`, {
          method:  "PUT", headers: {
            "Accept": "application/json, text/plain, */*", "Content-Type": "application/json"
          }, body: JSON.stringify( body )
        } )
      }
      return res
    } )
    .then( (order) => {
      if ( order ) {
        api.signals.updated.dispatch( { order: api.order } )
      }
      console.info( "ServiceRequest::statechange", stateCode, message, order )
      return order
    } )
    .catch( e => {
      console.warn( "ServiceRequest::statechange::failed", e )
    } )
}

const isError = (response) => {
  let err = response[ 0 ]
  if ( err && err.IsRestException ) {
    return true
  }
  return false
}

api.loadOrder = () => {
  // let url = `$ api_url /Form`
  // let url = `https://192.168.178.59:44300/mfr/${order_id}?token=MzExNjI2ODVfNjA2MDI3Nzc2XzQyNTUwODg2NA2`
  // let url = `/order-demo-1.json`
  return request(
    "/?$expand=Comments,Reports,Customer,Appointments/Contacts,ServiceObjects/Contacts,Steps/Attachments,Items,Documents,CurrentOwner" )
    .then( res => {
      let order = res.Order || res
      _LTracker.push( { message: "EXTERNALTECHNICIAN: ServiceRequest::loaded " + order.Id, level: "INFO" } )
      api.order      = new Order( order )
      api.order_data = order
      api.signatureStore.setOrder({order})
      return api.order
    } )
}

api.postSignatureStep = () => {
  let order        = api.getOrder()
  let maxSortOrder = 0
  if ( order.Steps.length > 0 ) {
    maxSortOrder = order.Steps
      .map( step => step.SortOrder )
      .reduce( (max, sortOrder) => Math.max( max, sortOrder ) )
  }
  const stepData = {
    ServiceRequestId: order.Id,
    Name:             "Unterschrift Techniker",
    Type:             3,
    Data:             JSON.stringify( { isRequired: 1, name: "Signstep", timeStamp: moment().format( "YYYY-MM-DD HH:mm:ss") } ),
    IsDone:           false,
    SortOrder:        maxSortOrder + 1,
    HasError:         false,
    TypeCode:         "SignDocument",
    TrackingId:       TRACK_ID_EXTRA_SIGNATURE
  }
  let body       = JSON.stringify( stepData )
  _LTracker.push( { message: "EXTERNALTECHNICIAN: ServiceRequest::postSignatureStep " + order.Id, level: "INFO" } )

  request( "/Step", {
    method:  "post",
    body:    body,
    headers: {
      "Accept": "application/json, text/plain, */*", "Content-Type": "application/json"
    }
  } )
    .then( res => {
      order.Steps.push( new Step( res ) )
      return res
    } )
}

api.canUpdate = () => {
  return api.order.StateCode !== "eIsWorkDone" && api.order.StateCode !== "eClosed"
}

api.putStep = (step) => {
  step.IsDone = true // TODO: Create step progress checking and error handling/nacharbeit
  let originalStep = step
  step        = _.cloneDeep( step )

  if ( step.Data && step.Data.fields && step.Data.fields.field ) {
    _.each( step.Data.fields.field, (field, key) => {
      let result   = step.fields[ key ].result
      field.result = result
      delete field.config
    } )
  }
  delete step.fields
  step.Data = JSON.stringify( step.Data )
  _LTracker.push( {
    message: `EXTERNALTECHNICIAN: ServiceRequest::updating Step ${step.SortOrder} ${step.Id}`,
    level:   "INFO"
  } )
  request( "/Step", {
    method:  "PUT",
    body:    JSON.stringify( step ),
    headers: {
      "Accept": "application/json, text/plain, */*", "Content-Type": "application/json"
    }
  } )
    .then( res => {
      if (res && res.Version) {
        originalStep.Version = res.Version
      }
      setTimeout( api.progress, 520 )
      return res
    } )
}

api.postDocument = ({ files }) => {
  let body = new FormData()
  _.each( files, file => body.append( `u-${file.name}`, file, file.filename || file.name ) )
  return request( `/Document`, {
    method: "POST", body
  } )
    .catch( e => {
      console.warn( e )
    } )
}

api.postAttachment = ({ files, stepId }) => {
  let body = new FormData()
  _.each( files, file => body.append( `u-${file.name}`, file, file.filename || file.name ) )
  return request( `/Attachment/${stepId}`, {
    method: "POST", body
  } )
    .catch( e => {
      console.warn( e )
    } )
}

api.postSignature = ({ files, name, step, title = "Kunde" }) => {
  if ( !api.canUpdate() ) return Promise.reject( "Document already signed" )
  if ( !name ) console.error( "Can't post a signature without a name" )

  let timeStamp = moment().format( "YYYY-MM-DD HH:mm:ss" )
  step.isDone   = true
  step.Data     = { name: name, isRequired: 1, timeStamp: timeStamp }
  step.Name     = `Unterschrift ${title}: ` + name
  return api.postAttachment( {
    files, stepId: step.Id
  } )
    .then( () => {
      api.signatureStore.signStep({step})
      return api.putStep( step )
    } )
}

api.parseDate = function(dateString, format) {
  let dateObject = date.parse( dateString, format )
  if ( !dateObject ) {
    return new Date()
  }
  return dateObject
}

api.track = (what) => {
  window.ga( "send", "event", what )
}

api.dataURLtoBlob = (dataURL) => {
  let binary = atob( dataURL.split( "," )[ 1 ] )
  let array  = []
  let i      = 0
  while ( i < binary.length ) {
    array.push( binary.charCodeAt( i ) )
    i++
  }
  return new Blob( [ new Uint8Array( array ) ], { type: "image/png" } )
}

api.getSubcontractor = () => {
  let order = api.getOrder()
  return order.CollaboratingContact
}
api.token            = token

function makeDateHumanreadable(dateString, format = "ddd MMM DD YYYY", isUTC = true) {
  let dateObj = date.parse( dateString, "YYYY-MM-DDTHH:mm:ss", isUTC )
  if ( !dateObj ) return "invalid Date"
  let dateHuman = date.format( dateObj, format, false )
  return dateHuman
}

// DEBUG
window.api = api
export default api



// WEBPACK FOOTER //
// ./src/api.js